import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { WebcamService } from '../service/webcam.service';
import { MatDialogRef } from '@angular/material';
var DeleteWebcamComponent = /** @class */ (function () {
    function DeleteWebcamComponent(_matDialogRef, data, _webcamService) {
        this._matDialogRef = _matDialogRef;
        this._webcamService = _webcamService;
        this.isLoading = false;
        this.webcamId = data.webcamId;
        this.airportID = data.airportID;
    }
    DeleteWebcamComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeleteWebcamComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteWebcamComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._webcamService.deleteWebcam(this.airportID, this.webcamId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeleteWebcamComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteWebcamComponent;
}());
export { DeleteWebcamComponent };
